

/**
 * @name UpdateAppointmentController
 * @description Controller for updating appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} NOTIFICATIONS Description
 * @param {type} Session Description
 * @param {type} Notification Description
 * @param {type} appointment Description
 * @param {type} project Description
 * @param {type} _ Lodash
 * @param {type} Participants The Participants service
 * @param {type} $rootScope The Angular $rootScope service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 * @param {angular} $log The Angular $log service
 */
function UpdateAppointmentController(
  $uibModalInstance,
  Appointment,
  NOTIFICATIONS,
  Session,
  Notification,
  appointment, // The resolved appointment from the modal
  project, // The resolved project from the modal
  _,
  Participants,
  $rootScope,
  collectorWantsNotif,
  $log
) {
  let vm = this;
  // Defaults
  vm.voidStatus = true;
  vm.appointmentTmp = _.cloneDeep(appointment);
  vm.appointmentCompare = _.cloneDeep(appointment);
  vm.projectTmp = _.cloneDeep(project);

  // Exposed Functions
  vm.submitDisabled = submitDisabled;
  vm.update = update;

  /**
  * @name submitDisabled
  * @description Disable the submit button
  * @return {Unknown} Unknown
  */
  function submitDisabled() {
    return ((vm.appointmentTmp.artist.id &&
    !vm.appointmentTmp.appointment_datetime) && (vm.appointmentTmp.artist.id &&
    !vm.appointmentTmp.appointment_date &&
    !vm.appointmentTmp.appointment_start_time));
  }

  /**
  * @name update
  * @description Function to update an appointment.
  * @param {object} appointmentToUpdate The appointment to be updated.
  */
  function update(appointmentToUpdate) {
    let status = 40;
    Appointment.update(appointmentToUpdate, status)
    .then(function(appointment) {
      // Check to see if an artist is found on the appointment
      if (vm.appointmentCompare.artist === null) {
        // If so, create a participant for the new artist if the collector and
        // artist are not the same user
        if (vm.projectTmp.collector.id === appointment.artist.id) {
          $rootScope.$broadcast('refresh-participants');
          $uibModalInstance.close(appointment);
        } else {
          let newArtistParticipant = {
            role: Session.activeState.role,
            conversation_id: appointment.conversations,
            collector_id: appointment.artist.id,
            appointment_id: appointment.id
          };
          Participants.create(newArtistParticipant).then(function() {
            $rootScope.$broadcast('refresh-participants');
            $uibModalInstance.close(appointment);
          });
        }

      // If the artist doesn't change, close the modal and return the appt
      } else if (vm.appointmentCompare.artist.id === appointment.artist.id) {
        $uibModalInstance.close(appointment);

      // If the artist has changed, update the Participants
      } else {
        // Get all participants to find the former artist's participant
        Participants.get(appointment.conversations)
        .then(function(participants) {
          // Find the participant for the former artist
          const formerArtistParticipant =
          _.find(participants, function(participant) {
            if (vm.appointmentCompare.artist.id === participant.collector) {
              return true;
            }
          });

          // Delete the former artist's participant if it exists
          if (formerArtistParticipant) {
            Participants.remove(formerArtistParticipant.id);
          }

          // Now create a participant for the new artist if the collector and
          // artist are not the same user and the new artist doesn't alredy
          // have a participant
          const newArtistParticipant =
          _.find(participants, function(participant) {
            if (appointment.artist.id === participant.collector) {
              return true;
            }
          });
          if (vm.projectTmp.collector.id === appointment.artist.id ||
          newArtistParticipant) {
            $rootScope.$broadcast('refresh-participants');
            $uibModalInstance.close(appointment);
          } else {
            let newArtistParticipant = {
              role: Session.activeState.role,
              conversation_id: appointment.conversations,
              collector_id: appointment.artist.id,
              appointment_id: appointment.id
            };
            Participants.create(newArtistParticipant).then(function() {
              $rootScope.$broadcast('refresh-participants');
              $uibModalInstance.close(appointment);
            });
          }
        });
      }

      // Send an email notification
      if (!(_.isEqual(vm.appointmentTmp, vm.appointmentCompare))) {
        // Email to collector
        let collectorNotification = {
          recipients: [project.collector.id],
          notificationId: NOTIFICATIONS.appointmentUpdate,
          messageObjects: {
            appointmentId: appointment.id,
            projectId: project.id,
            // The artist assigned to the appointment
            artistId: appointment.artist.id,
            // The operator updating the appointment
            operatorId: Session.collector.id,
            // The collector who owns the project
            collectorId: project.collector.id
          },
          messageVariables: {
            subject: project.collector.first_name +
            ', ' + Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ' updated the appointment for your project on Ink Finder'
          }
        };
        if (Session.activeState.association.shop.id) {
          collectorNotification.messageObjects.shopId =
          Session.activeState.association.shop.id;
          collectorNotification.messageVariables.subject =
          project.collector.first_name +
          ', ' + Session.collector.first_name + ' ' +
          Session.collector.last_name + ' at ' +
          Session.activeState.association.shop.name +
          ' updated the appointment for your project on Ink Finder';
        }
        Notification.send(collectorNotification);

        // Email to artist. Only send if the logged in user is not the artist
        // on the appt and the artist wants the notification
        collectorWantsNotif
        .check(appointment.artist.id, appointment.shop,
        'appointment_updated', 'artist')
        .then(function(collectorWantsNotif) {
          if (appointment.artist.id !==
          Session.collector.id && collectorWantsNotif) {
            let artistNotification = {
              recipients: [appointment.artist.id],
              notificationId: NOTIFICATIONS.artistAppointmentUpdate,
              messageObjects: {
                appointmentId: appointment.id,
                projectId: project.id,
                // The artist assigned to the appointment
                artistId: appointment.artist.id,
                // The operator updating the appointment
                operatorId: Session.collector.id,
                // The collector who owns the project
                collectorId: project.collector.id
              },
              messageVariables: {
                subject: project.collector.first_name +
                ', ' + Session.collector.first_name + ' ' +
                Session.collector.last_name +
                ' updated the appointment for a project you’re working on'
              }
            };
            Notification.send(artistNotification);
          }
        });
      }
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('UpdateAppointmentController', UpdateAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/update/update.controller.js